exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\r\n  color: white;\r\n  background-color: #343434;\r\n}\r\n\r\n.modal-footer {\r\n  background-color: #eeeeee;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/views/view-group/popups/confirm-popup copy/confirm-popup.component.css
// module id = ../../../../../src/app/content-page/views/view-group/popups/confirm-popup copy/confirm-popup.component.css
// module chunks = main